// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_i4-a";
export var fulfillmentFormRail = "_i4-9";
export var headerTitleRow = "_i4-c";
export var orderDetailsWrapper = "_i4-7";
export var orderLinkTrigger = "_i4-2";
export var paymentInformationGrid = "_i4-h";
export var paymentSummaryColumn = "_i4-i";
export var shipmentContainer = "_i4-b";
export var shipmentDetailsMainPane = "_i4-8";
export var shipmentNavigationCard = "_i4-5";
export var shipmentNavigationRail = "_i4-3";
export var shipmentNavigationRailHeader = "_i4-4";
export var shipmentSummaryFact = "_i4-e";
export var shipmentSummaryGrid = "_i4-d";
export var shipmentSummaryMetadataRow = "_i4-f";
export var shipmentSummaryTags = "_i4-g";
export var shipmentWorkspace = "_i4-0";
export var shipmentWorkspaceContent = "_i4-6";
export var shipmentWorkspaceHeader = "_i4-1";